import React from 'react';
import {
  PlanSetHeaderSection,
  PlanSetDetailSection
} from 'modules';
import { Box } from '@mui/material';


export const PlanSetActivity = () => {
  return (
    <Box>
      <PlanSetHeaderSection.FC />
      <PlanSetDetailSection.FC />
    </Box>

  );
};
